import IdText from '@/components/common/IdText';

interface NumberedIdProps {
  readonly value: string;
}

// Номер сделки или заявки: «№» обычным шрифтом, неразрывный пробел, значение — моноширинным.
export default function NumberedId({ value }: NumberedIdProps) {
  return (
    <>
      №{' '}
      <IdText>{value}</IdText>
    </>
  );
}
